export default function DSA_Dijkstra() {
  return <div>DSA_Dijkstra Component</div>;
}
